import getValue from './keyvalue/selectors/getValue';

export const CMS_TITLE_KEY = '_cmsPageTitle';

export const getCmsPageTitle = getValue(CMS_TITLE_KEY);
